import UserSettingsPage from "@components/user-settings/pages/UserSettingsPage";
import Layout from "@layout/Layout";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import MyOrdersListPage from "../my-orders/pages/MyOrdersListPage";

const UserEditViewPage = lazy(() => import("../user-profile/pages/UserEditViewPage"));
const UserPasswordChangePage = lazy(() => import("../user-profile/pages/UserPasswordChangePage"));

let Route: RouteObject = {
    element: <Layout isProtected />,
    children: [
        {
            path: "/user-settings",
            element: <UserSettingsPage />,
        },
        {
            path: "/user-settings/:userId/my-orders/",
            element: <MyOrdersListPage />,
        },
        {
            path: "/user-settings/:userId/edit/",
            element: <UserEditViewPage />,
        },
        {
            path: "/user-settings/:userId/password-change/",
            element: <UserPasswordChangePage />,
        }
    ],
}

export default Route;
